<template>
  <div
    id="simple-loan-payment-calculator"
    class="grid +mg-bottom-sm"
    :class="classNames"
  >
    <div class="grid-cell calculator__gray-bg +pd-sm size-1of2--xs">
      <div class="calculator__gray-bg">
        <numeric-input
          :title="'Principal:'"
          :name="'principal'"
          :error="config.principal.error"
          :min-value="config.principal.min"
          :max-value="config.principal.max"
          :prefix="'$'"
          :format="'commaFormat'"
          :model="currentPrincipal"
          v-model="currentPrincipal"
          ref="currentPrincipalInput"
        ></numeric-input>

        <numeric-input
          :title="'Interest:'"
          :name="'interest'"
          :error="config.interest.error"
          :min-value="config.interest.min"
          :max-value="config.interest.max"
          :suffix="'%'"
          :format="'commaFormat'"
          :model="currentInterest"
          v-model="currentInterest"
          ref="currentInterestInput"
        ></numeric-input>

        <numeric-input
          :title="'Number of years:'"
          :name="'numberOfYears'"
          :error="config.numberOfYears.error"
          :min-value="config.numberOfYears.min"
          :max-value="config.numberOfYears.max"
          :suffix="' years'"
          :show-suffix="false"
          :allow-decimals="false"
          :format="'commaFormat'"
          :model="currentNumberOfYears"
          v-model="currentNumberOfYears"
          ref="currentNumberOfYearsInput"
        ></numeric-input>

        <button
          id="calculate"
          @click="calculateMonthlyPayment"
          class="button --primary --full-width --small +mg_top-xs"
        >
          Calculate
        </button>
      </div>
    </div>
    <div
      class="grid-cell calculator__results-section +pd-sm +text-center size-1of2--xs"
    >
      <div id="calculation-results">
        <p class="calculator__calibre">
          <strong>Your monthly payment:</strong>
        </p>
        <p class="numeral --alpha" id="monthlyPayment">
          <span class="numeral__accent --currency">$</span
          >{{ savingsLoanMonthlyPayment | commaFormat }}
        </p>
      </div>
      <a
        href="/loans/personal-loans/rates/"
        class="button --secondary --small --full-width"
        v-on:click="trackRateRequest"
        >Compare Loan Rates
      </a>
    </div>
  </div>
</template>

<script>
import config from './config'
import { mapGetters } from 'vuex'
import numericInput from 'apps/legacy-components/numeric-input'
import eventHub from 'apps/bankrate-events'
import helpers from 'js/calculators/helpers'
import { isEmpty } from 'lodash'
import calculatorEventBus from 'apps/bankrate-calculators/events'

export default {
  components: {
    'numeric-input': numericInput
  },
  created() {
    this.currentPrincipal = isEmpty(this.savingsLoanPrincipal)
      ? ''
      : this.$options.filters['commaFormat'](this.savingsLoanPrincipal)
    this.currentInterest = isEmpty(this.savingsLoanInterest)
      ? ''
      : this.savingsLoanInterest
    this.currentNumberOfYears = isEmpty(this.savingsLoanNumberOfYears)
      ? ''
      : this.savingsLoanNumberOfYears
  },

  data() {
    return {
      config: config,
      currentPrincipal: '',
      currentInterest: '',
      currentNumberOfYears: ''
    }
  },

  computed: {
    ...mapGetters([
      'savingsLoanPrincipal',
      'savingsLoanInterest',
      'savingsLoanNumberOfYears',
      'savingsLoanMonthlyPayment'
    ]),

    classNames() {
      return helpers.detectDeviceType() === 'desktop'
        ? 'calculator__container'
        : '+border-bottom'
    }
  },

  methods: {
    trackRateRequest() {
      calculatorEventBus.$emit('calculator:requestRateTable')
    },
    calculateMonthlyPayment() {
      // Check for Errors
      let errorsFound = false

      // Validate inputs
      if (this.currentPrincipal === '') {
        errorsFound |= this.$refs.currentPrincipalInput.isBlank(
          this.config.principal.blank
        )
      } else {
        errorsFound |= this.$refs.currentPrincipalInput.hasDisplayError(true)
      }

      if (this.currentInterest === '') {
        errorsFound |= this.$refs.currentInterestInput.isBlank(
          this.config.interest.blank
        )
      } else {
        errorsFound |= this.$refs.currentInterestInput.hasDisplayError(true)
      }

      if (this.currentNumberOfYears === '') {
        errorsFound |= this.$refs.currentNumberOfYearsInput.isBlank(
          this.config.numberOfYears.blank
        )
      } else {
        errorsFound |= this.$refs.currentNumberOfYearsInput.hasDisplayError(
          true
        )

        if (this.currentNumberOfYears.toString().indexOf('.') !== -1) {
          errorsFound |= true
          this.$refs.currentNumberOfYearsInput.showDisplayError(
            'Please enter a number without a decimal point'
          )
        }
      }

      if (!errorsFound) {
        eventHub.$emit('calculator:calculation')

        return this.$store.dispatch('calculateSavingsSimpleLoanPayment', {
          principal: this.currentPrincipal,
          interest: this.currentInterest,
          years: this.currentNumberOfYears
        })
      }
    }
  }
}
</script>
